import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from 'reactstrap/lib/Card';

import {
  PricingCreativeConfigDefaultProps,
  PricingCreativeConfigPropTypes,
} from 'client/data/models/native-ads-creative-config';
import {
  SiteServedAdDefaultProps,
  SiteServedAdPropTypes,
} from 'site-modules/shared/components/ad-unit/ad-unit-prop-types';
import { PRICING_AD } from 'site-modules/shared/components/native-ad/utils/constants';
import { DfpTracking } from 'client/site-modules/shared/components/native-ad/utils/dfp-tracking';
import { addZipCode, definePlatform } from 'site-modules/shared/components/native-ad/utils/utils';
import { siteServedAdTrackingWrapper } from 'site-modules/shared/components/native-ad/site-served-ad-tracking-wrapper/site-served-ad-tracking-wrapper';
import { CtaUI } from 'site-modules/shared/components/native-ad/multi-cta-ad/components/cta';
import './pricing-site-served-ad.scss';

export function PricingSiteServedAdCtaOnlyUI({
  adRef,
  adClickTrackingListener,
  adLoadTrackingListener,
  adTrackers,
  creativeConfig = PricingCreativeConfigDefaultProps,
  mobile = SiteServedAdDefaultProps.mobile,
  position = SiteServedAdDefaultProps.position,
  cardClassName = null,
  ivtClassName = SiteServedAdDefaultProps.ivtClassName,
}) {
  const {
    siteServedAdsUpdater,
    zipCode,
    creativeConfigData: { lineItemId, siteServedCreativeId, cta, target },
    traffickingData: { clickTracker },
  } = creativeConfig;

  const loadTrackingListener = useCallback(
    event => {
      adLoadTrackingListener(event, cta);
    },
    [adLoadTrackingListener, cta]
  );

  const ctaURL = addZipCode(clickTracker[definePlatform(mobile)], zipCode);
  const ctaTarget = target || '_blank';

  const nativeStyle = PRICING_AD.NATIVE_STYLE;

  return (
    <div className={classnames('pricing-site-served-ad-unit', ivtClassName)}>
      <Card
        className={classnames('pricing-site-served-card', cardClassName)}
        data-tracking-parent={nativeStyle}
        data-viewability={`${nativeStyle}-${position}`}
        innerRef={adRef}
        style={{ minHeight: '0', border: 'none' }}
      >
        <DfpTracking
          lineItemId={lineItemId}
          siteServedCreativeId={siteServedCreativeId}
          mobile={mobile}
          nativeStyle={nativeStyle}
          position={position}
          slotRenderEndListener={loadTrackingListener}
          siteServedAdsUpdater={siteServedAdsUpdater}
        />
        {adTrackers}
        <CtaUI
          ctaURL={ctaURL}
          ctaTarget={ctaTarget}
          adClickTrackingListener={adClickTrackingListener}
          cta={'See All Trims'}
        />
      </Card>
    </div>
  );
}

PricingSiteServedAdCtaOnlyUI.propTypes = {
  ...SiteServedAdPropTypes,
  creativeConfig: PricingCreativeConfigPropTypes,
  cardClassName: PropTypes.string,
  wrapperClass: PropTypes.string,
};

export const PricingSiteServedAdCtaOnly = siteServedAdTrackingWrapper(PricingSiteServedAdCtaOnlyUI);
